import React, { Component } from 'react';
import { Button, Form, FormGroup, Input, FormFeedback } from 'reactstrap'
import Header from '../../Componentes/header'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import Fetch from '../../Auxiliares/fetch'
import history from '../../historial'

export default class primerInicio extends Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: '',
            contraseña: '',
            confcontraseña: '',
            errors: {}

        }

        this.update = this.update.bind(this)
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value })
    }

    componentDidMount() {
        if(localStorage.getItem('id'))this.setState({_id: localStorage.getItem('id')})
    }
    

    update() {
        let errors = {}
        const { contraseña, confcontraseña, _id } = this.state;
        if (!contraseña === confcontraseña) errors.contraseña = "Las contraseñas no coinciden"
        this.setState({ errors })

        if (Object.keys(errors).length === 0) {
            Fetch('/api/primerInicio', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ _id, contraseña })
            })
                .then(response => {
                        localStorage.removeItem('id')
                        history.push('/')
                })
                .catch(err => {
                    switch (err.status) {

                        case 600:
                            console.log('Error inesperado')
                            break;

                        case 602:
                            console.log('usario no encontrado')
                            break;
                            
                        default:
                            break;
                    }
                })
        }
    }


    render() {
        return (
            <html>
                <Header />
                <div className="container">
                    <div className="login-page">
                        <div className="form">

                            <Form className="login-form" method="post" encType="multipart/form-data">
                                <h3>Restablecer contraseña</h3>
                                <div className="container">
                                    <br></br>
                                    <FormGroup>
                                        <Input type="password" onChange={this.setValue.bind(this, "contraseña")} invalid={this.state.errors.contraseña} placeholder="Contraseña" name="contraseña" />
                                        <FormFeedback>{this.state.errors.contraseña}</FormFeedback>
                                    </FormGroup>

                                    <FormGroup>
                                        <Input type="password" onChange={this.setValue.bind(this, "confcontraseña")} value={this.state.confcontraseña} placeholder="Confirmar contraseña" name="confcontraseña" />
                                        <FormFeedback>{this.state.errors.confcontraseña}</FormFeedback>
                                    </FormGroup>

                                    <Button onClick={() => this.update()}>Guardar</Button>
                                </div>
                            </Form>

                        </div>
                    </div>
                </div>
                <Footer />
            </html>
        )
    }
}
